import { BoardSummary } from 'app/trello/models/board-summary';
import { DateRange } from 'app/trello/models/date-range';
import { Label } from 'app/trello/models/labels';
import { List } from 'app/trello/models/lists';
import { Member } from 'app/trello/models/members';

export interface BoardSummaryReportState {

  boardSummary: {
    data: BoardSummary | null;
    dateRange: DateRange | null;
    loading: boolean;
    loaded: boolean;
    error: string | null;
  };

  comparableBoardSummary: {
    data: BoardSummary | null;
    dateRange: DateRange | null;
    loading: boolean;
    loaded: boolean;
    error: string | null;
  };

  labels: {
    data: Label[];
    loading: boolean;
    loaded: boolean;
    error: string | null;
  };

  lists: {
    data: List[];
    loading: boolean;
    loaded: boolean;
    error: string | null;
  };

  members: {
    data: Member[];
    loading: boolean;
    loaded: boolean;
    error: string | null;
  };
}

export const initialState: BoardSummaryReportState = {

  boardSummary: {
    data: null,
    dateRange: null,
    loading: false,
    loaded: false,
    error: null,
  },

  comparableBoardSummary: {
    data: null,
    dateRange: null,
    loading: false,
    loaded: false,
    error: null,
  },

  labels: {
    data: [],
    loading: false,
    loaded: false,
    error: null,
  },

  lists: {
    data: [],
    loading: false,
    loaded: false,
    error: null,
  },

  members: {
    data: [],
    loading: false,
    loaded: false,
    error: null,
  }
};
